import { Component, OnInit } from "@angular/core";
import { FormGroup, FormArray, Validators } from "@angular/forms";
import { MemberappBaseComponent } from "../groupportal-base/groupportal-base.component";
import { Group, GroupInfo, AcepContact, SearchContact } from '../../../shared/models/group-portal-data.models';

import {
	ChapterDetails,
	ChapterInfo,
} from "../../../shared/models/chapter-details";
declare var $: any;
declare var moment: any;
@Component({
	selector: "myGroup .d-flex.pl-3",
	templateUrl: "./myGroup.component.html",
	styleUrls: ["./myGroup.component.scss"],
})
export class MyGroupComponent extends MemberappBaseComponent {
	showSearchContactList = false;
	monthList = [];
	selectedContact: any;
	deletedContact: Boolean = false;
	formsubmitted: Boolean = false;
	maxResidencyDirector: Boolean = false;
	maxResidencyCoordinator: Boolean = false;
	maxGroupAdmin: Boolean = false;
	//Paresh: Coding-1860 
	maxEMRAResRep: Boolean = false;
	maxEMRAResAltRep: Boolean = false;
	showEndDate: boolean = false;
	todayDate: Date = new Date();
	dateEntered: boolean = true;
	existingDateEdit: boolean = false;
	//

	ngOnInit() {
		this.setMonthsList();
	}

	//AkshayG: Remove extra space on page load for modal pop up
	ngAfterViewInit(): void {
		const deleteConfirmModal = $('[data-remodal-id=deleteParticipant]');
		const endDateconfirmmodal = $('[data-remodal-id=setPastEndDate]');
	
		//hide modal pop up div
		if (deleteConfirmModal) {
			this.setModalVisibility(deleteConfirmModal,'none','hidden')
		}

		if (endDateconfirmmodal) {
			this.setModalVisibility(endDateconfirmmodal,'none','hidden')
		}

	  }
	
	

	setMonthsList() {
		const months = new Array(
			"January",
			"February",
			"March",
			"April",
			"May",
			"June",
			"July",
			"August",
			"September",
			"October",
			"November",
			"December"
		);
		var mythis = this;
		for (var i = 0; i < 12; i++) {
			var popMonthsDDL: any;
			popMonthsDDL = {
				ddlValue: months[i],
			};
			mythis.monthList.push(popMonthsDDL);
		}
	}

	toggleSection(sectionName) {
		this.groupPortalDataService.toggleSection(sectionName);
		if (sectionName === "editProgramLeadership") {
			//Paresh: Coding-1860 copy original end date in temp column
			this.groupPortalDataService.groupList.FormGroupInfo.groupContacts.forEach(element => {
				element.tempEndDate = element.endDate;
			});
			//
			this.checkLeadershipAmounts();
		}
	}

	saveGroupInformation(programLeadership?) {
		programLeadership = (programLeadership ? programLeadership : 'false');
		this.formsubmitted = true;
		this.groupPortalDataService.showGroupInfo = false;
		const validLeadership = this.checkLeadershipAmounts();
		const validProgramInfo = this.checkInfoFields();
		if ((this.groupPortalDataService.newContact.contactNo !== null && this.groupPortalDataService.newContact.position === '') || !validLeadership || !validProgramInfo) {
			this.groupPortalDataService.showGroupInfo = true;
			return false;
		}
		this.groupPortalDataService.groupList.GroupInfo = this.groupPortalDataService.groupList.FormGroupInfo;
		if (this.groupPortalDataService.newContact.contactNo !== null) {
			this.addNewLeadership();
		}
		//Paresh: Coding-1860 set updated end date to original column
		this.groupPortalDataService.groupList.FormGroupInfo.groupContacts.forEach(element => {
			element.endDate = element.tempEndDate;
		});
		//
		this.updateSocialMediaUrls();
		this.groupPortalDataService.updateGroupInformation();
		this.deletedContact = false;
		this.formsubmitted = false;
		//Paresh: Coding-1860
		this.showEndDate = false;
		this.existingDateEdit = false;
		//Paresh: Coding-1860 copy original end date in temp column
		this.groupPortalDataService.groupList.FormGroupInfo.groupContacts.forEach(element => {
			element.tempEndDate = element.endDate;
		});
		//
		//
	}

	checkInfoFields() {
		let isValid = true;
		if (this.groupPortalDataService.groupList.FormGroupInfo.street === null || this.groupPortalDataService.groupList.FormGroupInfo.street === ''
			|| this.groupPortalDataService.groupList.FormGroupInfo.city === null || this.groupPortalDataService.groupList.FormGroupInfo.city === ''
			|| this.groupPortalDataService.groupList.FormGroupInfo.country === null || this.groupPortalDataService.groupList.FormGroupInfo.country === ''
			|| (this.groupPortalDataService.groupList.FormGroupInfo.state === null || this.groupPortalDataService.groupList.FormGroupInfo.state === '' &&
				this.groupPortalDataService.ui_stateprovinces.length > 0)
			|| (this.groupPortalDataService.groupList.FormGroupInfo.zip === null || this.groupPortalDataService.groupList.FormGroupInfo.zip === ''
				&& this.groupPortalDataService.groupList.FormGroupInfo.country === 'US')) {
			isValid = false;
		}
		return isValid;

	}

	updateSocialMediaUrls() {
		if (this.groupPortalDataService.groupList.GroupInfo.twitter !== null && this.groupPortalDataService.groupList.GroupInfo.twitter !== '' && !this.groupPortalDataService.groupList.GroupInfo.twitter.includes("twitter.com")) {
			if (this.groupPortalDataService.groupList.GroupInfo.twitter.substring(0, 1) === '@') {
				this.groupPortalDataService.groupList.GroupInfo.twitter = "https://twitter.com/" + this.groupPortalDataService.groupList.GroupInfo.twitter.substring(1, this.groupPortalDataService.groupList.GroupInfo.twitter.length);
			} else {
				this.groupPortalDataService.groupList.GroupInfo.twitter = "https://twitter.com/" + this.groupPortalDataService.groupList.GroupInfo.twitter;
			}
		} else if (this.groupPortalDataService.groupList.GroupInfo.twitter !== null && this.groupPortalDataService.groupList.GroupInfo.twitter !== '' && !this.groupPortalDataService.groupList.GroupInfo.twitter.includes("http")) {
			this.groupPortalDataService.groupList.GroupInfo.twitter = "https://" + this.groupPortalDataService.groupList.GroupInfo.twitter;
		}
		if (this.groupPortalDataService.groupList.GroupInfo.facebook !== null && this.groupPortalDataService.groupList.GroupInfo.facebook !== '' && !this.groupPortalDataService.groupList.GroupInfo.facebook.includes("facebook.com")) {
			if (this.groupPortalDataService.groupList.GroupInfo.facebook.substring(0, 1) === '@') {
				this.groupPortalDataService.groupList.GroupInfo.facebook = "https://facebook.com/" + this.groupPortalDataService.groupList.GroupInfo.facebook.substring(1, this.groupPortalDataService.groupList.GroupInfo.facebook.length);
			} else {
				this.groupPortalDataService.groupList.GroupInfo.facebook = "https://facebook.com/" + this.groupPortalDataService.groupList.GroupInfo.facebook;
			}
		} else if (this.groupPortalDataService.groupList.GroupInfo.facebook !== null && this.groupPortalDataService.groupList.GroupInfo.facebook !== '' && !this.groupPortalDataService.groupList.GroupInfo.facebook.includes("http")) {
			this.groupPortalDataService.groupList.GroupInfo.facebook = "https://" + this.groupPortalDataService.groupList.GroupInfo.facebook;
		}
		if (this.groupPortalDataService.groupList.GroupInfo.instagram !== null && this.groupPortalDataService.groupList.GroupInfo.instagram !== '' && !this.groupPortalDataService.groupList.GroupInfo.instagram.includes("instagram.com")) {
			if (this.groupPortalDataService.groupList.GroupInfo.instagram.substring(0, 1) === '@') {
				this.groupPortalDataService.groupList.GroupInfo.instagram = "https://instagram.com/" + this.groupPortalDataService.groupList.GroupInfo.instagram.substring(1, this.groupPortalDataService.groupList.GroupInfo.instagram.length);
			} else {
				this.groupPortalDataService.groupList.GroupInfo.instagram = "https://instagram.com/" + this.groupPortalDataService.groupList.GroupInfo.instagram;
			}
		} else if (this.groupPortalDataService.groupList.GroupInfo.instagram !== null && this.groupPortalDataService.groupList.GroupInfo.instagram !== '' && !this.groupPortalDataService.groupList.GroupInfo.instagram.includes("http")) {
			this.groupPortalDataService.groupList.GroupInfo.instagram = "https://" + this.groupPortalDataService.groupList.GroupInfo.instagram;
		}
		if (this.groupPortalDataService.groupList.GroupInfo.youtube !== null && this.groupPortalDataService.groupList.GroupInfo.youtube !== '' && !this.groupPortalDataService.groupList.GroupInfo.youtube.includes("youtube.com")) {
			if (this.groupPortalDataService.groupList.GroupInfo.youtube.substring(0, 1) === '@') {
				this.groupPortalDataService.groupList.GroupInfo.youtube = "https://youtube.com/" + this.groupPortalDataService.groupList.GroupInfo.youtube.substring(1, this.groupPortalDataService.groupList.GroupInfo.youtube.length);
			} else {
				this.groupPortalDataService.groupList.GroupInfo.youtube = "https://youtube.com/" + this.groupPortalDataService.groupList.GroupInfo.youtube;
			}
		} else if (this.groupPortalDataService.groupList.GroupInfo.youtube !== null && this.groupPortalDataService.groupList.GroupInfo.youtube !== '' && !this.groupPortalDataService.groupList.GroupInfo.youtube.includes("http")) {
			this.groupPortalDataService.groupList.GroupInfo.youtube = "https://" + this.groupPortalDataService.groupList.GroupInfo.youtube;
		}
		if (this.groupPortalDataService.groupList.GroupInfo.vimeo !== null && this.groupPortalDataService.groupList.GroupInfo.vimeo !== '' && !this.groupPortalDataService.groupList.GroupInfo.vimeo.includes("vimeo.com")) {
			if (this.groupPortalDataService.groupList.GroupInfo.vimeo.substring(0, 1) === '@') {
				this.groupPortalDataService.groupList.GroupInfo.vimeo = "https://vimeo.com/" + this.groupPortalDataService.groupList.GroupInfo.vimeo.substring(1, this.groupPortalDataService.groupList.GroupInfo.vimeo.length);
			} else {
				this.groupPortalDataService.groupList.GroupInfo.vimeo = "https://vimeo.com/" + this.groupPortalDataService.groupList.GroupInfo.vimeo;
			}
		} else if (this.groupPortalDataService.groupList.GroupInfo.vimeo !== null && this.groupPortalDataService.groupList.GroupInfo.vimeo !== '' && !this.groupPortalDataService.groupList.GroupInfo.vimeo.includes("http")) {
			this.groupPortalDataService.groupList.GroupInfo.vimeo = "https://" + this.groupPortalDataService.groupList.GroupInfo.vimeo;
		}
	}


	//Paresh: Coding-1860 new function to understand the existing record date is changed
	editDateContact: any = null;
	onEndDateChanged(contact) {
		let endDate = contact.tempEndDate;

		if (endDate == null || endDate == "") {
			this.dateEntered = false;
			return;
		}
		if (endDate < this.todayDate) {
			this.editDateContact = contact;
			const endDateconfirmmodal = $(
				"[data-remodal-id=setPastEndDate]"
			);
			//AkshayG: Open modal pop up
			this.setModalVisibility(endDateconfirmmodal,'inline-block','show') 
			endDateconfirmmodal.remodal().open();
		} else {
			this.existingDateEdit = true;
			this.checkLeadershipAmounts();
		}
	}
	//

	checkLeadershipAmounts() {
		let groupAdminCount = 0;
		let resDirectorCount = 0;
		let resCoordinatorCount = 0;
		//Paresh: Coding-1860
		let emraResRep = 0;
		let emraResAltRep = 0;
		this.showEndDate = false;
		this.dateEntered = true;
		let emptyDateCount = 0;
		//
		const groupContacts = this.groupPortalDataService.groupList.FormGroupInfo.groupContacts;
		groupContacts.forEach(contact => {
			if (contact.position === 'Group Administrator') {
				groupAdminCount++;
			}
			if (contact.position === 'Residency Director') {
				resDirectorCount++;
			}
			if (contact.position === 'Coordinator') {
				resCoordinatorCount++;
			}

			//Paresh: Coding-1860
			if (contact.position === this.groupPortalDataService.EMRAResRepText && (this.ConvertStringToDate(contact.tempEndDate) > this.ConvertStringToDate(this.todayDate.toDateString()))) {
				emraResRep++;
			}
			if (contact.position === this.groupPortalDataService.EMRAResAltRepText && (this.ConvertStringToDate(contact.tempEndDate) > this.ConvertStringToDate(this.todayDate.toDateString()))) {
				emraResAltRep++;
			}
			if ((contact.position === this.groupPortalDataService.EMRAResRepText || contact.position === this.groupPortalDataService.EMRAResAltRepText) && (contact.tempEndDate == null || contact.tempEndDate == "")) {
				emptyDateCount++;
			}
			//
		});
		if (this.groupPortalDataService.newContact.contactNo !== null && this.groupPortalDataService.newContact.position === 'Group Administrator') {
			groupAdminCount++;
		}
		if (this.groupPortalDataService.newContact.position === 'Residency Director') {
			resDirectorCount++;
		}
		if (this.groupPortalDataService.newContact.position === 'Coordinator') {
			resCoordinatorCount++;
		}
		//Paresh: Coding-1860
		if (this.groupPortalDataService.newContact.position === this.groupPortalDataService.EMRAResRepText) {
			emraResRep++;
			this.showEndDate = true;
		}
		if (this.groupPortalDataService.newContact.position === this.groupPortalDataService.EMRAResAltRepText) {
			emraResAltRep++;
			this.showEndDate = true;
		}
		//

		this.maxGroupAdmin = groupAdminCount > 3;
		this.maxResidencyCoordinator = resCoordinatorCount > 1;
		this.maxResidencyDirector = resDirectorCount > 1;
		//Paresh: Coding-1860
		this.maxEMRAResRep = emraResRep > 1;
		this.maxEMRAResAltRep = emraResAltRep > 1;
		if (emptyDateCount > 0 || (this.showEndDate && !this.maxEMRAResRep && !this.maxEMRAResAltRep && (this.groupPortalDataService.newContact.tempEndDate == null || this.groupPortalDataService.newContact.tempEndDate == ""))) {
			this.dateEntered = false;
		}
		//

		//Paresh: Coding-1860 added !this.maxEMRAResRep && !this.maxEMRAResAltRep && this.dateEntered
		return !this.maxGroupAdmin && !this.maxResidencyDirector && !this.maxResidencyCoordinator && !this.maxEMRAResRep && !this.maxEMRAResAltRep && this.dateEntered;
	}

	searchForMembers(event) {
		if (event.keyCode === 27) {
			this.closeListBlock();
		} else {
			this.showSearchContactList = true;
			if (this.groupPortalDataService.newContact.formalName.length > 2) {
				this.groupPortalDataService.searchForContact(this.groupPortalDataService.newContact.formalName);
			} else {
				this.groupPortalDataService.resetSearchContactList();
			}
		}
	}

	addNewLeadership() {
		this.groupPortalDataService.groupList.FormGroupInfo.groupContacts.push(this.groupPortalDataService.newContact);
		this.groupPortalDataService.setNewContact();
	}

	setshowContactForm(contacts, show) {
		this.showSearchContactList = false;

		if (contacts !== 0) {
			this.groupPortalDataService.newContact.formalName = contacts.formalName;
			this.groupPortalDataService.newContact.email = contacts.emailAddress1;
			this.groupPortalDataService.newContact.contactNo = contacts.acepId;
		} else {
			const contact = new AcepContact;

			this.groupPortalDataService.setEditContactInfo(contact);
			this.groupPortalDataService.resetSearchContactList();
			this.addNewContactForLeadership();
		}
	}
	closeListBlock(event?) {
		this.groupPortalDataService.newContact.formalName = '';
		this.showSearchContactList = false;
		this.groupPortalDataService.resetSearchContactList();
	}

	addNewContactForLeadership() {
		this.scrollToTop();
		this.groupPortalDataService.SetSlideOutType("addLeadership");
		this.SideNavDisplay('open');
	}

	scrollToTop() {
		$("html,body").animate(
			{
				scrollTop: $(".gpTop").offset().top
			},
			"medium"
		);
	}

	confirmRemoveParticipant(member: any) {
		this.selectedContact = member;
		const deleteconfirmmodal = $(
			"[data-remodal-id=deleteParticipant]"
		)
		//AkshayG: Open modal pop up  
		this.setModalVisibility(deleteconfirmmodal,'inline-block','show')
		deleteconfirmmodal.remodal().open();
	}

	deleteContact() {
		let newGroupList = [];
		const groupContacts = this.groupPortalDataService.groupList.FormGroupInfo.groupContacts;
		groupContacts.forEach(contact => {
			if (contact.contactNo !== this.selectedContact.contactNo || contact.position !== this.selectedContact.position) {
				newGroupList.push(contact);
			}
		});
		this.groupPortalDataService.groupList.FormGroupInfo.groupContacts = newGroupList;
		this.deletedContact = true;
		this.checkLeadershipAmounts();
		this.cancelModal();
	}

	cancelModal() {
		let deleteconfirmmodal = $(
			"[data-remodal-id=deleteParticipant]"
		).remodal();
		deleteconfirmmodal.close();
	}

	//Paresh: Coding-1860
	closeEndDateModel() {
		let endDateconfirmmodal = $(
			"[data-remodal-id=setPastEndDate]"
		).remodal();
		endDateconfirmmodal.close();
	}
	cancelEndDateModal() {
		this.editDateContact.tempEndDate = this.editDateContact.endDate;
		this.existingDateEdit = false;
		this.closeEndDateModel();
	}

	changeEndDate() {
		this.existingDateEdit = true;
		this.checkLeadershipAmounts();
		this.closeEndDateModel();
	}
	//

	onCountrySelect(countrycode) {
		this.groupPortalDataService.refreshStateProvinces();
	}


	getCountryFromCode(countrycode) {
		var c = this.dataService.uidata?.Countries.filter(a => a.acep_iso2code == countrycode)[0].acep_name;
		return c;
	}

	public SantizeDate(date: string): string {
		if (date == "" || date == null) return "";
		return moment(date).format("MM/DD/YYYY");
	}

	//Paresh: Bug-2266 Added code to convert string into Date 
	public ConvertStringToDate(date: string): Date {
		if (date == "" || date == null) return null;
		return moment(moment(date).format("MM/DD/YYYY"));
	}
}
